export const isAlphaNum = (code) =>
  (code >= 0x30 /* 0 */ && code <= 0x39) /* 9 */ ||
  (code >= 0x41 /* A */ && code <= 0x5a) /* Z */ ||
  (code >= 0x61 /* a */ && code <= 0x7a); /* z */
